import { useEffect, useState } from "react"
import { useLocation } from "react-router"

const useMyFeed = () => {
    const [isRoute, setRoute] = useState<boolean>(false)
    const location = useLocation() 
    useEffect(() => { 
        setRoute( location.pathname.indexOf( "my-feed" ) > -1 )
    }, [location])
    return isRoute
}
export default useMyFeed